import { Injectable } from '@angular/core';
import { LoraChart } from './../../../assets/data/enum/loraChart.enum';

@Injectable()
export class ParamMetaDataMapperService {
  mapping: object = {};

  initialize() {
    this.mapping[LoraChart.RSSI] = { sideIcon: '', scale: 'dbm' };
    this.mapping[LoraChart.SNR] = { sideIcon: '', scale: 'SNR' };
    this.mapping[LoraChart.LiquidLevel] = { sideIcon: '', scale: 'cm' };
    this.mapping[LoraChart.LiquidTemperature] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.PH] = { sideIcon: '', scale: 'pH' };
    this.mapping[LoraChart.LeafWetness] = { sideIcon: '', scale: 'mV' };
    this.mapping[LoraChart.WM1] = { sideIcon: '', scale: 'min' };
    this.mapping[LoraChart.WM2] = { sideIcon: '', scale: 'min' };
    this.mapping[LoraChart.SM] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM1] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM2] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM3] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM4] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM5] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.SM6] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.ST] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST1] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST2] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST3] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST4] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST5] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.ST6] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS1] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS2] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS3] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS4] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS5] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.SS6] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.MR] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.MR1] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.MR2] = { sideIcon: '', scale: '%' };
    this.mapping[LoraChart.At] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.Ah] = { sideIcon: '', scale: '% rel' };
    this.mapping[LoraChart.Rm] = { sideIcon: '', scale: 'mm' };
    this.mapping[LoraChart.Aws] = { sideIcon: '', scale: 'km/h' };
    this.mapping[LoraChart.Mws] = { sideIcon: '', scale: 'km/h' };
    this.mapping[LoraChart.Ap] = { sideIcon: '', scale: 'mPa' };
    this.mapping[LoraChart.LUX] = { sideIcon: '', scale: 'Lux' };
    this.mapping[LoraChart.Atd] = { sideIcon: '', scale: '°C' };
    this.mapping[LoraChart.Bv] = { sideIcon: '', scale: 'V' };
    this.mapping[LoraChart.Sr] = { sideIcon: '', scale: 'W/m2' };
    this.mapping[LoraChart.Awa] = { sideIcon: '', scale: '°' };
  }

  getIcon(property: string) {
    return this.mapping[property] ? this.mapping[property].sideIcon : null;
  }

  getScale(property: string) {
    return this.mapping[property] ? this.mapping[property].scale : null;
  }
}
